import React, { useRef } from "react";
import logoImage from "../image/dharajlogo.jpeg";

const currency = (n) => `₹${n.toLocaleString("en-IN")}`;

const InvoicePage = ({ invoice }) => {
  const invoiceRef = useRef();

  if (!invoice) return null;

  const subtotal = invoice.items.reduce((sum, item) => sum + item.qty * item.price, 0);
  const grandTotal = subtotal + (invoice.delivery || 0) - (invoice.discount || 0);

  const handleDownload = () => {
    const printContent = invoiceRef.current;
    const printWindow = window.open("", "_blank", "width=794,height=1123");
    
    const getBase64Image = (img) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      return canvas.toDataURL('image/png');
    };

    const img = new Image();
    img.src = logoImage;
    img.onload = () => {
      const logoBase64 = getBase64Image(img);

      printWindow.document.write(`
        <html>
          <head>
            <title>Invoice - ${invoice.invoiceNo}</title>
            <style>
              :root {
                --color-primary: #298b31;
                --color-secondary: #fff;
                --color-ternary: #ffd54d;
                --color-accent: #f3faf1;
                --color-text: #2A2A2A;
                --color-muted: #7D7D7D;
                --border-radius-btn: 12px;
                --radius-sm: 0.5rem;
                --font-primary: 'Montserrat', sans-serif;
                --font-secondary: 'Montserrat', sans-serif;
                --font-xs: 1.2rem;
                --font-sm: 1.4rem;
                --font-base: 1.6rem;
                --font-lg: 2rem;
                --font-xl: 2.4rem;
                --font-xxl: 3rem;
                --space-xs: 0.5rem;
                --space-sm: 1rem;
                --space-md: 2rem;
                --space-lg: 3rem;
              }

              @page { 
                size: A4 portrait; 
                margin: 10mm; 
              }
              body { 
                font-family: var(--font-primary); 
                color: var(--color-text);
                margin: 0;
                padding: 0;
                line-height: 1.4;
                background: white;
                font-size: var(--font-xs);
              }
              .invoice-container {
                max-width: 100%;
                margin: 0 auto;
                padding: var(--space-sm);
                page-break-inside: avoid;
                page-break-after: avoid;
              }
              .invoice-content {
                page-break-inside: avoid;
                page-break-after: avoid;
              }
              .invoice-header {
                text-align: left;
                
                margin-bottom: var(--space-sm);
                padding-bottom: var(--space-xs);
                page-break-after: avoid;
              }
              .invoice-title {
                font-size: var(--font-xl);
                font-weight: bold;
                color: var(--color-primary);
                margin-bottom: var(--space-xs);
              }
              .company-section {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                margin-bottom: var(--space-sm);
                gap: var(--space-sm);
                page-break-inside: avoid;
              }
              .logo-container {
                flex: 1;
              }
              .logo-container img {
                max-width: 150px;
                height: auto;
              }
              .seller-info {
                flex: 2;
                text-align: right;
                background: var(--color-accent);
                padding: var(--space-sm);
                border-radius: var(--radius-sm);
                
                font-size: var(--font-xs);
              }
              .buyer-meta-section {
                display: flex;
                justify-content: space-between;
                gap: var(--space-sm);
                margin-bottom: var(--space-sm);
                page-break-inside: avoid;
              }
              .buyer-info {
                flex: 2;
                background: var(--color-accent);
                padding: var(--space-sm);
                border-radius: var(--radius-sm);
                
                font-size: var(--font-xs);
              }
              .meta-info {
                flex: 1;
                background: var(--color-accent);
                padding: var(--space-sm);
                border-radius: var(--radius-sm);
                
                font-size: var(--font-xs);
              }
              .section-title {
                font-size: var(--font-sm);
                font-weight: bold;
                color: var(--color-primary);
                margin-bottom: var(--space-xs);
               
                padding-bottom: var(--space-xs);
              }
              .info-line {
                margin: var(--space-xs) 0;
                font-size: var(--font-xs);
              }
              .invoice-table {
                width: 100%;
                border-collapse: collapse;
                margin: var(--space-sm) 0;
                font-size: var(--font-xs);
                border: 1px solid #e5e7eb;
                page-break-inside: avoid;
              }
              .invoice-table th {
                background: var(--color-primary);
                color: var(--color-secondary);
                font-weight: bold;
                padding: var(--space-xs) var(--space-xs);
                text-align: left;
                border: 1px solid var(--color-primary);
                font-size: var(--font-xs);
              }
              .invoice-table td {
                padding: var(--space-xs);
                border: 1px solid #e5e7eb;
                text-align: left;
                font-size: var(--font-xs);
              }
              .invoice-table tr:nth-child(even) {
                background: var(--color-accent);
              }
              .totals-section {
                margin-top: var(--space-sm);
                text-align: right;
                font-size: var(--font-sm);
                page-break-inside: avoid;
              }
              .total-line {
                margin: var(--space-xs) 0;
                display: flex;
                justify-content: flex-end;
                gap: var(--space-sm);
              }
              .total-label {
                min-width: 80px;
                text-align: right;
              }
              .total-value {
                min-width: 100px;
                text-align: left;
              }
              .grand-total {
                font-weight: bold;
                font-size: var(--font-base);
                color: var(--color-primary);
                border-top: 1px solid #e5e7eb;
                padding-top: var(--space-xs);
                margin-top: var(--space-xs);
              }
              .footer-section {
                margin-top: var(--space-md);
                text-align: center;
                padding: var(--space-sm);
                border-top: 1px solid #e5e7eb;
                font-size: var(--font-xs);
                color: var(--color-muted);
                page-break-inside: avoid;
              }
              .thank-you {
                font-weight: bold;
                color: var(--color-primary);
                margin-bottom: var(--space-xs);
              }
              .no-print {
                display: none;
              }
              .keep-together {
                page-break-inside: avoid;
                page-break-after: avoid;
              }
              @media print {
                body {
                  font-size: var(--font-xs);
                }
                .invoice-container {
                  padding: 0;
                  margin: 0;
                }
              }
            </style>
          </head>
          <body>
            <div class="invoice-container">
              ${printContent.innerHTML}
            </div>
          </body>
        </html>
      `);
      
      setTimeout(() => {
        const printImg = printWindow.document.querySelector('.logo-container img');
        if (printImg) {
          printImg.src = logoBase64;
        }
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.onafterprint = () => printWindow.close();
      }, 500);
    };
  };

  return (
    <>
      <style>{`
        .invoice-wrap {
          background: var(--color-accent);
          padding: var(--space-md);
          min-height: 100vh;
          font-family: var(--font-primary);
          color: var(--color-text);
        }
        .invoice-container {
          background: var(--color-secondary);
          border: 1px solid #d1d5db;
          padding: var(--space-md);
          max-width: 794px;
          margin: 0 auto;
          border-radius: var(--radius-sm);
          box-shadow: var(--shadow-sm);
        }
        .invoice-content {
          display: flex;
          flex-direction: column;
          gap: var(--space-sm);
        }
        .invoice-header {
          text-align: left;
          
          margin-bottom: var(--space-sm);
          padding-bottom: var(--space-xs);
        }
        .invoice-title {
          font-size: var(--font-xl);
          font-weight: bold;
          color: var(--color-primary);
          margin-bottom: var(--space-xs);
        }
        .company-section {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: var(--space-sm);
          gap: var(--space-sm);
        }
        .logo-container {
          flex: 1;
        }
        .logo-container img {
          max-width: 150px;
          height: auto;
          border-radius: var(--radius-sm);
        }
        .seller-info {
          flex: 2;
          text-align: right;
          
          padding: var(--space-sm);
          border-radius: var(--radius-sm);
          
          font-size: var(--font-xs);
        }
        .buyer-meta-section {
          display: flex;
          justify-content: space-between;
          gap: var(--space-sm);
          margin-bottom: var(--space-sm);
        }
        .buyer-info {
          flex: 2;
          
          padding: var(--space-sm);
          border-radius: var(--radius-sm);
          
          font-size: var(--font-xs);
        }
        .meta-info {
          flex: 1;
          
          padding: var(--space-sm);
          border-radius: var(--radius-sm);
          text-align: right;
          font-size: var(--font-xs);
        }
        .section-title {
          font-size: var(--font-sm);
          font-weight: bold;
          color: var(--color-primary);
          margin-bottom: var(--space-xs);
         
          padding-bottom: var(--space-xs);
        }
        .info-line {
          margin: var(--space-xs) 0;
          font-size: var(--font-xs);
        }
        .invoice-table {
          width: 100%;
          border-collapse: collapse;
          margin: var(--space-sm) 0;
          font-size: var(--font-xs);
          border: 1px solid #e5e7eb;
        }
        .invoice-table th {
          background: var(--color-primary);
          color: var(--color-secondary);
          font-weight: bold;
          padding: var(--space-xs) var(--space-xs);
          text-align: left;
          border: 1px solid var(--color-primary);
          font-size: var(--font-xs);
        }
        .invoice-table td {
          padding: var(--space-xs);
          border: 1px solid #e5e7eb;
          text-align: left;
          font-size: var(--font-xs);
        }
        .invoice-table tr:nth-child(even) {
          background: var(--color-accent);
        }
        .totals-section {
          margin-top: var(--space-sm);
          text-align: right;
          font-size: var(--font-sm);
        }
        .total-line {
          margin: var(--space-xs) 0;
          display: flex;
          justify-content: flex-end;
          gap: var(--space-sm);
        }
        .total-label {
          min-width: 80px;
          text-align: right;
        }
        .total-value {
          min-width: 100px;
          text-align: left;
        }
        .grand-total {
          font-weight: bold;
          font-size: var(--font-base);
          color: var(--color-primary);
          border-top: 1px solid #e5e7eb;
          padding-top: var(--space-xs);
          margin-top: var(--space-xs);
        }
        .footer-section {
          margin-top: var(--space-md);
          text-align: center;
          padding: var(--space-sm);
          border-top: 1px solid #e5e7eb;
          font-size: var(--font-xs);
          color: var(--color-muted);
        }
        .thank-you {
          font-weight: bold;
          color: var(--color-primary);
          margin-bottom: var(--space-xs);
        }
        .print-btn-container {
          text-align: center;
          margin-top: var(--space-md);
        }
        .btn-primary {
          background: var(--color-primary);
          color: var(--color-secondary);
          border: none;
          padding: var(--space-sm) var(--space-md);
          border-radius: var(--border-radius-btn);
          cursor: pointer;
          font-size: var(--font-sm);
          font-weight: bold;
          transition: all 0.3s ease;
          box-shadow: var(--shadow-sm);
        }
        .btn-primary:hover {
          background: var(--bg-main2);
          transform: translateY(-2px);
          box-shadow: var(--shadow-md);
        }
        @media print {
          .invoice-wrap {
            background: white;
            padding: 0;
          }
          .invoice-container {
            box-shadow: none;
            border: none;
            padding: var(--space-sm);
            margin: 0;
          }
          .print-btn-container {
            display: none;
          }
        }
        @media (max-width: 820px) {
          .invoice-wrap {
            padding: var(--space-sm);
          }
          .invoice-container {
            padding: var(--space-sm);
          }
          .company-section, .buyer-meta-section {
            flex-direction: column;
          }
          .seller-info {
            text-align: left;
          }
        }
          
      `}</style>

      <div className="invoice-wrap">
        <div className="invoice-container" ref={invoiceRef}>
          <div className="invoice-content keep-together">
            {/* HEADER */}
            <div className="invoice-header">
              <div className="invoice-title">TAX INVOICE</div>
            </div>

            {/* COMPANY & SELLER INFO */}
            <div className="company-section keep-together">
              <div className="logo-container">
                <img src={logoImage} alt="Company Logo" crossOrigin="anonymous" />
              </div>
              <div className="seller-info">
                <div className="section-title">From</div>
                <div className="info-line"><strong>{invoice.seller.name}</strong></div>
                <div className="info-line">{invoice.seller.address}</div>
                <div className="info-line">GSTIN: {invoice.seller.gstin}</div>
                <div className="info-line">Phone: {invoice.seller.phone}</div>
              </div>
            </div>

            {/* BUYER & META INFO */}
            <div className="buyer-meta-section keep-together">
              <div className="buyer-info">
                <div className="section-title">Bill To</div>
                <div className="info-line"><strong>{invoice.buyer.name}</strong></div>
                <div className="info-line">{invoice.buyer.address}</div>
                <div className="info-line">Phone: {invoice.buyer.phone}</div>
              </div>
              <div className="meta-info">
                <div className="section-title">Invoice Details</div>
                <div className="info-line"><strong>Invoice No:</strong> {invoice.invoiceNo}</div>
                <div className="info-line"><strong>Order Date:</strong> {invoice.orderDate}</div>
                <div className="info-line"><strong>Payment:</strong> {invoice.paymentMethod}</div>
              </div>
            </div>

            {/* ITEMS TABLE */}
            <table className="invoice-table keep-together">
              <thead>
                <tr>
                  <th style={{width: '8%'}}>S.No</th>
                  <th style={{width: '52%'}}>Product Description</th>
                  <th style={{width: '10%'}}>Qty</th>
                  <th style={{width: '15%'}}>Unit Price</th>
                  <th style={{width: '15%'}}>Total Price</th>
                </tr>
              </thead>
              <tbody>
                {invoice.items.map((item, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{item.title}</td>
                    <td>{item.qty}</td>
                    <td>{currency(item.price)}</td>
                    <td>{currency(item.qty * item.price)}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* TOTALS SECTION */}
            <div className="totals-section keep-together">
              <div className="total-line">
                <div className="total-label">Subtotal:</div>
                <div className="total-value">{currency(subtotal)}</div>
              </div>
              <div className="total-line">
                <div className="total-label">Shipping:</div>
                <div className="total-value">
                  {invoice.delivery === 0 ? "Free" : currency(invoice.delivery)}
                </div>
              </div>
              {invoice.discount > 0 && (
                <div className="total-line">
                  <div className="total-label">Discount:</div>
                  <div className="total-value">-{currency(invoice.discount)}</div>
                </div>
              )}
              <div className="total-line grand-total">
                <div className="total-label">Grand Total:</div>
                <div className="total-value">{currency(grandTotal)}</div>
              </div>
            </div>

            {/* FOOTER */}
            <div className="footer-section keep-together">
              <div className="thank-you">Thank you for your business!</div>
              <div>For any queries, please contact us at {invoice.seller.phone}</div>
            </div>
          </div>

          {/* PRINT BUTTON */}
          <div className="print-btn-container">
            <button className="btn-primary" onClick={handleDownload}>
              Print Invoice
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoicePage;